import { onDocumentReady } from '../utils/events';

onDocumentReady(() => {
  const grid = document.getElementById('posts-grid');
  const loadMore = document.getElementById('posts-load-more');
  const filterButtons = document.querySelectorAll('.posts-listing__category');

  if (!grid) return;

  const API_URL = grid.dataset.api;
  const PER_PAGE = Number.parseInt(grid.dataset.perPage, 10) || 12;
  const LATEST_POST_ID = Number.parseInt(grid.dataset.latestPostId, 10) || 0;
  const LANGUAGE = grid.dataset.language || '';
  const INITIAL_CONTENT_TYPE = grid.dataset.initialContentType || '';

  let state = {
    paged: 1,
    contentType: INITIAL_CONTENT_TYPE,
    loading: false,
    totalPages: Number.parseInt(grid.dataset.totalPages, 10) || 1,
  };

  function setLoadingState(isLoading, showLoader = false) {
    state.loading = isLoading;
    grid.classList.toggle('is-loading', isLoading && showLoader);
    if (loadMore) {
      loadMore.disabled = isLoading;
      loadMore.classList.toggle('is-loading', isLoading && !showLoader);
      loadMore.setAttribute('aria-busy', String(isLoading && !showLoader));
    }
    filterButtons.forEach((btn) => (btn.disabled = isLoading));
  }

  function setActiveFilter(contentType) {
    filterButtons.forEach((btn) => {
      const active = (btn.dataset.contentType || '') === contentType;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', String(active));
    });
  }

  async function fetchPosts({
    append = false,
    showLoader = false,
    paged = state.paged,
    contentType = state.contentType,
  } = {}) {
    if (state.loading) return false;
    setLoadingState(true, showLoader);

    const url = new URL(API_URL, window.location.href);
    const params = url.searchParams;
    params.set('per_page', PER_PAGE);
    params.set('paged', paged);

    if (LATEST_POST_ID) params.set('exclude', LATEST_POST_ID);
    if (LANGUAGE) params.set('lang', LANGUAGE);
    if (contentType) params.set('content_type', contentType);
    else params.delete('content_type');

    try {
      const res = await fetch(url.toString());
      if (!res.ok) throw new Error(res.statusText);

      const data = await res.json();

      if (!append) grid.innerHTML = '';
      if (data.html) grid.insertAdjacentHTML('beforeend', data.html);

      state.paged = paged;
      state.contentType = contentType;
      state.totalPages = Number.parseInt(data.total_pages, 10) || 1;
      setActiveFilter(contentType);

      if (loadMore) {
        const hasMore = state.paged < state.totalPages;
        loadMore.style.display = hasMore ? 'inline-flex' : 'none';
      }

      return true;
    } catch (err) {
      console.error(err);
      return false;
    } finally {
      setLoadingState(false);
    }
  }

  loadMore?.addEventListener('click', () => {
    if (state.loading || state.paged >= state.totalPages) return;
    fetchPosts({ append: true, paged: state.paged + 1 });
  });

  filterButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (state.loading) return;
      const isAlreadyActive = btn.classList.contains('is-active');
      const nextContentType = btn.dataset.contentType || '';
      const contentType = isAlreadyActive ? '' : nextContentType;
      const header = document.querySelector('header');
      const headerHeight = header ? header.offsetHeight : 0;
      const extraOffset =
        parseFloat(getComputedStyle(document.documentElement).fontSize) * 2;

      const yOffset = -(headerHeight + extraOffset + 25);
      const y = grid.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({
        top: y,
        behavior: 'smooth',
      });
      fetchPosts({ showLoader: true, paged: 1, contentType });
    });
  });

  const urlParams = new URLSearchParams(window.location.search);
  const preselected = urlParams.get('type');

  if (preselected) {
    const selectorValue =
      window.CSS && CSS.escape ? CSS.escape(preselected) : preselected;
    const targetBtn = document.querySelector(
      `.posts-listing__category[data-content-type="${selectorValue}"]`
    );
    if (targetBtn) {
      fetchPosts({ showLoader: true, paged: 1, contentType: preselected });

      document
        .querySelector('.posts-listing')
        ?.scrollIntoView({ behavior: 'smooth' });
    }
  } else {
    setActiveFilter(INITIAL_CONTENT_TYPE);
  }
});
